<template>
  <div class="text-center pa-8" :style="`min-height: ${minHeight}px; display: flex; align-items: center; justify-content: center;`">
    <p>{{ $t('message.nenhum_registro', 1) }}</p>
  </div>
</template>

<script>
export default {
  name: 'GraficoVazio',
  props: {
    minHeight: {
      type: Number,
      default: 320,
    },
  },
};
</script>
